import { ActionWidget, ActionWidgetProps, RuntimeAction, SPI, Widget, http } from '@kunlun/dependencies';
import Comp from './AddActivityNav.vue';

interface CmNavRecord {
  id: number;
  code: string;
  name: string;
  navType: string;
  parentId?: number;
  parentCode?: string;
}

interface ActivityNavRelRecord {
  id?: number;
  sideNavId?: number;
  sideNavCode?: string;
  sideNavName?: string;
  sideNavSort?: number;
  horizontalNavId?: number;
  horizontalNavCode?: string;
  horizontalNavName?: string;
  horizontalNavSort?: number;
}

@SPI.ClassFactory(
  ActionWidget.Token({
    model: 'deli.aries.settlement.DeliAriesCmNavProxy',
    name: 'uiClient800275007097220601-17804032532520252sITM'
  })
)
export class AddActivityNavAction extends ActionWidget {
  public initialize(props: ActionWidgetProps<RuntimeAction>) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  @Widget.Method()
  public async queryNavTree() {
    const gql = `
      query {
        deliAriesCmNavQuery {
          queryPage(
            page: { currentPage: 1, size: 9999 }
            queryWrapper: { rsql: "(1==1)", queryData: {} }
          ) {
            content {
              id
              code
              name
              navType
              parentId
              parentCode
            }
          }
        }
      }
    `;
    const result = await http.query(this.model.moduleName, gql);
    return (result?.data?.deliAriesCmNavQuery?.queryPage?.content || []) as CmNavRecord[];
  }

  @Widget.Method()
  public getCurrentRows() {
    return (this.dataSource || []) as ActivityNavRelRecord[];
  }

  @Widget.Method()
  public setRootTableData(data: ActivityNavRelRecord[]) {
    const newArr = [...(this.dataSource || []), ...data];
    const uniqueArr: ActivityNavRelRecord[] = [];
    const uniqueMap: Record<string, ActivityNavRelRecord & { _sortIndex?: number }> = {};

    newArr.forEach((item, index) => {
      const key = (item.sideNavCode || `${item.sideNavCode || ''}-${item.horizontalNavCode || ''}`) as any;
      uniqueMap[key] = {
        ...item,
        _sortIndex: uniqueMap[key]?._sortIndex ?? index
      };
    });

    Object.keys(uniqueMap).forEach((key) => {
      uniqueArr.push(uniqueMap[key]);
    });
    uniqueArr.sort((a: any, b: any) => (a._sortIndex || 0) - (b._sortIndex || 0));
    uniqueArr.forEach((item: any) => {
      delete item._sortIndex;
    });

    this.reloadDataSource(uniqueArr as any);
    this.refreshCallChaining?.syncCall(true);
  }
}
